import { apiWithToken } from '../api';

const resouceUrl = '/nota_tecnica_ambiental';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const show = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
}

export const update = async (id, nota_tec_ambiental) => {
  return await api.put(`${resouceUrl}/${id}`, nota_tec_ambiental);
}



export const store = async (nota_tec_ambiental) => {
  let response = await api.post(resouceUrl , nota_tec_ambiental);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}
